import React, { useState } from "react";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { ProjectCard } from "../../components";

import "swiper/css";
import "swiper/css/pagination";
import styles from "./slider.scss";

const ProjectSlider = ({ projects, totalCount = null }) => {
  const [activeSlide, setSetActiveSlide] = useState(0);

  return (
    <div className="projects-slider-wrapper">
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        modules={[Pagination]}
        autoHeight={true}
        pagination={{
          el: ".project-slider_pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className}" key="${index}"></span>`;
          },
        }}
        onSlideChange={(i) => {
          setSetActiveSlide(i.activeIndex);
        }}
      >

        {projects.map((item, index) => {
          if (totalCount && index + 1 > totalCount) {
            return null;
          }

          return (
            <SwiperSlide>
              {" "}
              <ProjectCard item={item} key={index} squareThumbs={true} />{" "}
            </SwiperSlide>
          );
        })}

        <div className="project-slider_pagination"></div>
      </Swiper>
    </div>
  );
};

export default ProjectSlider;
